import { render, staticRenderFns } from "./ProductThumbnail.vue?vue&type=template&id=8aae8612&"
import script from "./ProductThumbnail.vue?vue&type=script&lang=ts&"
export * from "./ProductThumbnail.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports